import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getHubData } from 'api/HubAPI';
import { AppThunk } from 'app/store';
import { RootState } from 'app/rootReducer';

interface HubState {
  loading: boolean,
  errorMessage: string | undefined,
  hub: HubContext.Hub,
  isActivated: boolean,
}

const initialState: HubState = {
  loading: false,
  errorMessage: undefined,
  hub: undefined,
  isActivated: false
}

const hub = createSlice({
  name: 'hub',
  initialState,
  reducers: {
    getHubPending(state : HubState){
        state.loading = true;
    },
    getHubSuccess(state: HubState, action : PayloadAction<any>) {
     state.loading = false;
     state.hub = action.payload;
     state.isActivated = !!action.payload.id;
    },
    getHubFailed(state: HubState, action : PayloadAction<string>){
      state.loading = false;
      state.errorMessage = action.payload;
    }
  }
})

export const {
  getHubPending,
  getHubSuccess,
  getHubFailed
} = hub.actions

/**
 * Selectors
 */
export const hubData = (state: RootState) => state.hub.hub;
export const hubIsActive = (state: RootState) => state.hub.isActivated;
export const getProbeIds = (state: RootState) => state.hub.hub?.probeIds;

export default hub.reducer

// Thunks
export const getHubDataThunk = (): AppThunk => async (dispatch : any) => {
  dispatch(getHubPending());

  getHubData().then((response) => {
    dispatch(getHubSuccess(response));
  }).catch(e => {
    dispatch(getHubFailed(e));
  });
};